import React, { useEffect, useState } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import useFormName from '../../../../../Hooks/useFormName';
import useTranslation from '../../../../../Hooks/useTranslation';
import ErrorMessage from '../../../../../Components/Form/components/ErrorMessage';
import TopFieldContent from '../../../../../Components/Form/components/TopFieldContent';
import { InputProps } from '../../../../../Components/Form/components/Input';
import { useAppContext } from '../../../../../Services/AppContext';
import CurrencyInput from 'react-currency-input-field';
import { locales } from '../../../../utils/Hooks/usePrice';
import PriceCurrency from './PriceCurrency';
import { joinClasses } from '../../../../../Utils/className.util';

// @ts-ignore
import styles from './FormattedPriceInputField.module.scss';

interface Props extends InputProps {
	name: string;
	label?: string;
	isRequired?: boolean;
	className?: string;
	placeholder?: string;
}

const FormattedPriceInputField = ({
	name,
	label,
	isRequired,
	className,
	placeholder,
	onChange,
	...inputProps
}: Props) => {
	const { t } = useTranslation();
	const { fieldName } = useFormName({ name });
	const { currency, globalTemplate } = useAppContext();
	const { control } = useFormContext();
	const style: React.CSSProperties = {};

	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: fieldName,
		defaultValue: '',
	});

	const [value, setValue] = useState(field.value);

	const handleOnInputChange = (val: any) => {
		setValue(val);
	};

	useEffect(() => {
		field.onChange(value);
	}, [value]);

	if (currency === 'HUF' || currency === 'RSD') {
		style.paddingLeft = '50px';
	}

	return (
		<div className={className}>
			{label && <TopFieldContent label={label} isRequired={isRequired} />}
			<div className={styles.wrapper}>
				{currency !== 'CZK' && (
					<div className={styles.prefix}>
						<PriceCurrency currency={currency} />
					</div>
				)}
				<CurrencyInput
					className={joinClasses([
						styles.input,
						currency !== 'CZK' ? styles.inputPrefix : '',
					])}
					onValueChange={handleOnInputChange}
					intlConfig={{ locale: locales[globalTemplate], currency }}
					placeholder={t(placeholder)}
					prefix={' '}
					value={value}
					style={style}
				/>
				{currency === 'CZK' && (
					<div className={styles.suffix}>
						<PriceCurrency currency={currency} />
					</div>
				)}
			</div>
			{error?.message && <ErrorMessage tx={error.message} />}
		</div>
	);
};

export default FormattedPriceInputField;
